/**
 * This module is used to track the gclid query parameter in the URL.
 * We store the gclid in sessionStorage so that it can be used later
 * when the user submits a form.
 */

/**
 * Get the gclid query parameter from the URL
 * @returns {string} The gclid query parameter value
 */
const getGclidParam = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('gclid');
};

/**
 * Store tracking information in localStorage
 * @param {string} currentUrl - Full URL including query parameters
 */
const storeTrackingInfo = (currentUrl) => {
  // If paid traffic is already tracked, don't override the original landing page
  if (localStorage.getItem('paidTraffic') === 'true') {
    return;
  }

  localStorage.setItem('landingPage', currentUrl);
  localStorage.setItem('paidTraffic', 'true');
};

const populateFormFields = () => {
  const forms = [...document.querySelectorAll('.fui-form')];
  console.log('populateFormFields', forms);
  forms.forEach((form) => {
    console.log('form', form);
    const landingPage = localStorage.getItem('landingPage');
    const paidTraffic = localStorage.getItem('paidTraffic');

    const landingPageField = form.querySelector('input[name="fields[landingUrl]"]');
    const paidTrafficField = form.querySelector('input[name="fields[paidTraffic]"]');

    console.log('landingPageField', landingPageField);
    console.log('paidTrafficField', paidTrafficField);

    if (landingPageField && landingPage) {
      console.log('setting landingPageField', landingPageField.value, landingPage);
      landingPageField.value = landingPage;
    }

    if (paidTrafficField && paidTraffic) {
      console.log('setting paidTrafficField', paidTrafficField.value, paidTraffic);
      paidTrafficField.value = paidTraffic;
    }
  });
};

const CONSENT_CHECK_MAX_ATTEMPTS = 50;
const CONSENT_CHECK_INTERVAL_MS = 300;

const initLogic = () => {
  if (window.getCkyConsent) {
    const consent = getCkyConsent();
    console.log('campaignTracker - if getCkyConsent', consent);
    if (consent.categories.analytics && consent.categories.advertisement) {
      console.log('campaignTracker - if getCkyConsent and consent.categories.analytics && consent.categories.advertisement');
      const gclid = getGclidParam();
      if (gclid) {
        storeTrackingInfo(window.location.href);
      }
      populateFormFields();
    }
  } else {
    console.log('campaignTracker - else getCkyConsent');
    // check if getCkyConsent is defined 2 times per second for 10 seconds
    let attempts = 0;
    const checkInterval = setInterval(() => {
      if (window.getCkyConsent) {
        clearInterval(checkInterval);
        initLogic();
      } else {
        attempts++;
        if (attempts >= CONSENT_CHECK_MAX_ATTEMPTS) {
          clearInterval(checkInterval);
          console.error('campaignTracker - timed out waiting for getCkyConsent');
        }
      }
    }, CONSENT_CHECK_INTERVAL_MS);
  }
}

export default function init() {
  initLogic();

  document.addEventListener('cookieyes_consent_update', () => {
    initLogic();
  });
}
